export default __webpack_public_path__ + "static/media/2000.3745b02f.png";